import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import RankingTab from "./ranking-tab"
import {POINTS_RANKING_FIELDS} from "../../ducks/duck-ranking";
import {getTranslation} from "../../helpers/get-translation";

const styles = theme => ({
	root: {
		"flex": 1,
		"minHeight": 0,
		"display": "flex",
		"flex-flow": "column",
	},
	tabs: {
		flex: "0 0 auto",
		background: "white",
		boxShadow: "0px 4px 5px 0px rgba(0,0,0,0.14)"
	}
});

class RankingScreen extends React.Component {
	state = {
		page: 0,
		pointsSelectedFieldName: POINTS_RANKING_FIELDS[2],
		riddlesSelectedFieldName: POINTS_RANKING_FIELDS[5],
	};

	handlePageChange = (event, newPage) => {
		this.setState({page: newPage})
	};

	handleSelectionChange = (event) => {
		if(this.state.page === 1){
			this.setState({riddlesSelectedFieldName: event.target.value})
		} else {
			this.setState({pointsSelectedFieldName: event.target.value})
		}
	};


	render(){
		const { classes } = this.props

		const tabProps = {
			selectedFieldName: this.state.selectedFieldName,
			handleSelectionChange: this.handleSelectionChange,
			rankingList : this.props.ranking,
			isRankingLoading : this.props.isRankingLoading,
			activePlayerStats: this.props.activePlayerStats,
			activePlayerDisplayName: this.props.activePlayerDisplayName,
			activePlayerAvatar: this.props.activePlayerAvatar,
			rankingLanguage: this.props.rankingLanguage,
			isAnonymous: this.props.isAnonymous,
			fetchRanking: this.props.fetchRanking,
			resetRanking: this.props.resetRanking
		};


		return (
			<div className={classes.root}>
				<AppBar position="static" color="default" className={classes.tabs}>
					<Tabs
						value={this.state.page}
						onChange={this.handlePageChange}
						indicatorColor="primary"
						textColor="primary"
						variant="fullWidth"
					>
						<Tab label={getTranslation("ranking_score_navigation_points")} />
						<Tab label={getTranslation("ranking_score_navigation_logos")} />
					</Tabs>
				</AppBar>
				{this.state.page === 0 &&
				<RankingTab {...tabProps}
							scoreName={getTranslation("ranking_score_player_points")}
				            selectedFieldName={this.state.pointsSelectedFieldName}
				            menuItemValues={[POINTS_RANKING_FIELDS[0], POINTS_RANKING_FIELDS[1], POINTS_RANKING_FIELDS[2]]}/>}
				{this.state.page === 1 &&
				<RankingTab {...tabProps}
							scoreName={getTranslation("ranking_score_player_logos")}
				            selectedFieldName={this.state.riddlesSelectedFieldName}
				            menuItemValues={[POINTS_RANKING_FIELDS[3], POINTS_RANKING_FIELDS[4], POINTS_RANKING_FIELDS[5]]}/>}
			</div>
		);
	}

}

RankingScreen.propTypes = {
	isAnonymous: PropTypes.bool.isRequired,

	rankingLanguage: PropTypes.string.isRequired,
	activePlayerDisplayName: PropTypes.string.isRequired,
	activePlayerAvatar: PropTypes.string,

	ranking: PropTypes.object.isRequired,
	isRankingLoading: PropTypes.object.isRequired,
	activePlayerStats: PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired,

	fetchRanking: PropTypes.func.isRequired,
	resetRanking: PropTypes.func.isRequired,
	push: PropTypes.func.isRequired,
};

export default withStyles(styles)(RankingScreen);
